export enum TSAnlaufstelleType {
    KANTON = <any> 'KANTON',
    GEMEINDE = <any> 'GEMEINDE'
}

export function getTSAnlaufstelleTypeValues(): Array<TSAnlaufstelleType> {
    return [
        TSAnlaufstelleType.KANTON,
        TSAnlaufstelleType.GEMEINDE,
    ];
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSAnlaufstelleType.ts